import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({
    
    propTypes: {
        index: React.PropTypes.number.isRequired,
        payload: React.PropTypes.string.isRequired,
        text: React.PropTypes.string.isRequired,
        target: React.PropTypes.string,
        disabled: React.PropTypes.bool
    },
    
    getDefaultProps() {
        return {
            disabled: false
        };
    },
    
    render() {
        let classes = ClassNames('lui-menu-item', {
          'lui-is-disabled': this.props.disabled
        });
        let onClickHandler = (this.props.disabled) ? this._stopLink : undefined;
        // Prevent context menu 'Open In New Tab/Window'
        let linkAttribute = (this.props.disabled) ? 'data-href' : 'href';
        let link = {};
        link[linkAttribute] = this.props.payload
        
        return (
            <a key={this.props.index} className={classes} {...link} target={this.props.target} onClick={onClickHandler}>{this.props.text}</a>
        );
    },
    
    _stopLink(event) {
      event.preventDefault();
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menu/LinkMenuItem.js
 **/